import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import FlowerButton from "@/components/FlowerButton";
import { useCart } from "@/context/CartContext";
import { fmtPrice } from "@/data/mellow";
import { StockBadge, useStockInfo } from "@/components/StockBadge";

export const BundleTeaser = ({ product }) => {
  const { add } = useCart();
  const { soldOut } = useStockInfo(product?.lookup_key);
  if (!product) return null;
  return (
    <div className="relative overflow-hidden rounded-[2rem] border-2 border-dashed border-[#D1D5CB] bg-[#EEF1E4] p-6 md:p-8 flex flex-col sm:flex-row items-center gap-6" data-testid="bundle-teaser">
      <Link to={`/produit/${product.lookup_key}`} className="shrink-0"><img src={product.img} alt={product.name} className="w-32 h-40 sm:w-36 sm:h-48 object-cover rounded-2xl shadow-md" /></Link>
      <div className="flex-1 min-w-0 text-center sm:text-left">
        <p className="inline-flex items-center gap-2 font-cursive text-2xl text-[#78353A]/80"><Gift className="w-5 h-5" /> Lot découverte</p>
        <h3 className="font-cursive text-4xl md:text-5xl text-[#78353A] leading-none mt-1">Le carnet + le pense-bête, à prix doux</h3>
        <p className="mt-2 text-sm text-[#4A3B32]/85">{product.desc}</p>
        <div className="mt-4 flex flex-wrap items-center justify-center sm:justify-start gap-4">
          <span className="font-cursive text-4xl text-[#4A3B32] leading-none" data-testid="bundle-price">
            {fmtPrice(product.price)}
            {product.compareAt && <span className="ml-2 align-middle text-xl text-[#4A3B32]/50 line-through">{fmtPrice(product.compareAt)}</span>}
          </span>
          <FlowerButton variant="pink" className="!py-3 !px-5 !text-lg" onClick={() => add(product.lookup_key)} disabled={soldOut} data-testid={`add-to-cart-${product.lookup_key}`}>
            {soldOut ? "Épuisé" : "Ajouter le lot"}
          </FlowerButton>
          <StockBadge lookup_key={product.lookup_key} />
          <Link to={`/produit/${product.lookup_key}`} className="font-cursive text-xl text-[#78353A] underline decoration-dotted underline-offset-4" data-testid="bundle-link">Voir la fiche du lot</Link>
        </div>
      </div>
    </div>
  );
};
